module.exports = __webpack_public_path__ + "media/Components/fonts/boldLobsterTwo-a7c37ac758976786d28c4021dc014f64.ttf";